import React, { useState } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Container from '@components/Container';
import { localeData } from '@utils/locales';
import Logo from '@asserts/images/products/logo_vechain.png';

import { trunc, getQuery } from '@utils/tools';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: '#595959',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  select: {
    fontSize: rem(18),
    border: 'none',
    backgroundColor: '#FFF',
    lineHeight: 20,
    outline: 'none',
  },
  block: {
    margin: [rem(8), 0],
  },
  special: {
    fontSize: rem(14),
    color: '#57BCF9',
    marginRight: rem(5),
    fontWeight: 'bold',
  },
  blockID: {
    fontSize: rem(10),
    color: '#8C8C8C',
    border: '1px solid #F8F9FA',
    padding: rem(8),
    backgroundColor: '#F8F9FA',
  },
  line: {
    position: 'absolute',
    height: 6,
    width: '100%',
    background: 'linear-gradient(270deg, #57BCF9 24%, #5982FD 71%, #A162F6 100%)',
  },
}), {
  name: 'HeaderPage'
})

const HeaderPage = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { setLocale } = props;
  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language);

  const query = getQuery();

  const handleChangeLocale = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    setLocale(lng);
    setLanguage(lng);
  }

  return (
    <>
      <Container className={classNames(classes.root)}>
        <Container 
          flex 
          justify='space-between' 
          alignItems='center' 
          style={{ width: '100%' }}
        >
          <img src={Logo} alt="logo" width={120} />
          <select
            name='chain_language_select'
            className={classes.select}
            value={language}
            onChange={e => handleChangeLocale(e)}
          >
            {
              localeData && localeData.map(item => (
                <option 
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </option>
              ))
            }
          </select>
        </Container>

        <Container
          flex
          direction='column'
          className={classes.block}
        >
          <p>
            <span className={classes.special}>VID</span>
            <span>{t('evidence')}</span>
          </p>
          <span className={classes.blockID}>{trunc(query.vid, 15, 20)}</span>
        </Container>

      </Container>

      <span className={classes.line}></span>
    </>
  )
};

HeaderPage.propTypes = {
  setLocale: PropTypes.func.isRequired,
}

export default HeaderPage;
